/// <reference path="../../../services/data.service.ts" />
import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatPaginator } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/services/PermissionsService';
import { PASPrdService } from '../../../services/PASPrd.service';
import { AppService } from '../../../services/app.service';
import { ProductionService } from '../../../services/production.service';
import { RouterService } from '../../../services/router.service';
import { SecurityService } from '../../../services/security.service';
import { IComponentsData, IGroupComponentData } from '../../Interfaces/Integrations/IProduction';
import { IgrouppaslistResponse } from '../../Interfaces/igrouppas';
import { POGStatuses } from '../../Interfaces/iproduction';
import { IuserPermissionsResponse } from '../../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
import { CompositionDetailComponent } from './CompositionDetail.component';
import { FixedComponentAddComponent } from './FixedComponentAdd.component';

@Component({
  selector: 'app-pascomposition',
  templateUrl: './pascomposition.component.html'
})

export class PASCompositionComponent implements OnInit, AfterViewInit {

  subRef$: Subscription;
  gridRegs: number = 0;
  cardRegs: number = 0;
  public companyId: string;
  userId: string;
  matcher = new ErrorStateMatcher1();
  message: string="";
  Columns: string[] = [];
  dataGrid: IComponentsData[] = [];
  dataGridList = new MatTableDataSource<any>([]);
  dataCard: IGroupComponentData[] = [];
  dataCardList: any[]; // = new MatTableDataSource<any>([]);
  Permissions: IuserPermissionsResponse[] = [];
  menuPop: IuserPermissionsResponse[] = [];
  menuPopList = new MatTableDataSource;
  MenuG: IuserPermissionsResponse[] = [];
  permissionsList = null;
  menuGList =new MatTableDataSource;
  filtermenu = { type: 'G' };
  _CurrentId: number;
  _CurrentName: string;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  ngAfterViewInit() {
    try {
      this.dataGridList.paginator = this.paginator;
    }
    catch { }
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private securityService: SecurityService,
    private routeparent: RouterService,
    private productionService: ProductionService,
    private permissionService: PermissionsService,
    private pasPrdService: PASPrdService,
    private appService: AppService,
    private dialog: MatDialog,
    private securityParams: ActivatedRoute,
    private location: Location,
    private _snackBar: MatSnackBar
  ) {
    this.Columns = ['code', 'name', 'quantity', 'b_menu'];
    this.statuslist.push({ code: "A", name: "Activo" }, { code: "I", name: "Inactivo" });
  }
  selectedvalue: number; selectedview: string;
  group: IgrouppaslistResponse[];
  statuslist: POGStatuses[] = [];
  nPASId: number;

  ngOnInit() {
    this.nPASId = parseInt(this.securityParams.snapshot.params.pasid);
    this.message= "";
    //permisos
    this.Permissions = [];
    this.menuPop = [];
    this.MenuG = [];
    this.permissionService.getPermission("pascomposition").subscribe(results => {
      if (results.body.length == 0)
        this.message = "No tiene permisos";
      for (const entry of results.body) {
        this.addPermission(entry);
/*          { id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description, type: entry.type, icon: entry.icon, link: entry.link });*/
      }
      this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
      this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
      this.menuPopList = new MatTableDataSource<IuserPermissionsResponse>(this.menuPop);
    },
      (e) => {
        this.message  =  e.error;
        console.log(e);
      });
    this.GetData();
  }

  GetData() {
    //pasoptions
    this.message = "Consultando...";
    this.dataGrid = [];
    this.dataGridList = new MatTableDataSource<IComponentsData>(this.dataGrid);

    //this.dataGridList = null;
    this.dataCard = [];
    this.dataCardList = [];

 //   this.dataCardList = null;
    this.gridRegs = 0;
    this.cardRegs = 0;
    this.GetFixedComponents();
    //
    this.pasPrdService.GetComplexCompositionGroups(this.nPASId).subscribe(result => {
      if (!result.body.isValid) {
        this.message = result.body.error.description;
     }
      else {
        this.message = "";
        for (const entry of result.body.resultData)
        {
          this.AddCardData(entry);
        }
        this.dataCardList = this.dataCard; // new MatTableDataSource < IGroupComponentData > (this.dataCard);
        this.cardRegs = this.dataCard.length; // this.dataCardList.data.length;
      }
    },
      (e) => {
        this.openSB(e.error);
        console.log(e);
      });
  }

  GetFixedComponents() {
    this.pasPrdService.GetFixedComponents(this.nPASId).subscribe(result => {
      if (!result.body.isValid) {
        this.message = result.body.error.description;
      }
      else {
        this.message = "";
        for (const entry of result.body.resultData) {
          this.AddGridData(entry);
        }
        this.dataGridList = new MatTableDataSource<IComponentsData>(this.dataGrid);
        this.dataGridList.paginator = this.paginator;
        this.gridRegs = this.dataGridList.data.length;
      }
      if (this.appService.currentPage > 0) {
        this.paginator.pageIndex = this.appService.currentPage;
      }
      this.dataGridList.paginator = this.paginator;
    },
      (e) => {
        this.openSB(e.error);
        console.log(e);
      }); 

  }

  AddGridData(data) {
    this.dataGrid.push(data);
  }

  AddCardData(data) {
    switch (data.type)
    {
      case "A":
        data.icon = "checkbox-outline";
        break;
      case "O":
        data.icon = "checkbox-multiple-outline";
        break;
      case "F":
        data.icon = "format-list-bulleted";
        break;
      case "D":
        data.icon = "cube-outline";
    }
    this.dataCard.push(data);
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    switch (permission.type) {
      case "G":
        this.MenuG.push(permission);
        break;
      case "R":
        this.menuPop.push(permission);
        break;
    }
  }

  //b_det(id, name) {
  //  this.routeparent.putRouter("paslist");
  //  this.passervice.putValues(id, name)
  //  this.router.navigate(['/pasdetail']);
  //}

  b_back() {
    this.location.back();
  }


  b_gen(link,id,  pCode) {
    switch (pCode) {
      case "F":
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.panelClass = "my-class";
        dialogConfig.data = { pasId: this.nPASId };
        const dialogRef = this.dialog.open(FixedComponentAddComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(
          data => {
            if (data) {
              this.GetFixedComponents();
            }
          }, (e) => console.log(e)
        );
        break;
      case "A":
        this.b_Add();
        break;
      default:
        this.router.navigate([link]);
        break;
    }
  }

  GetCurrentId(Id: number, Name:string)
  {
    this._CurrentId = Id;
    this._CurrentName = Name;
  //  this.appService.PASOptionsGroupPutValues(this.formFilter.value.name, this.paginator.pageIndex);
  }

  menupopexecute(FunctionCode: string, PrmCode: string, Link: string) {
    //this.routeparent.putRouter("pasoptionsgroup");
    switch (PrmCode) {
      case "D":
        this.b_Detail(this._CurrentId);
        break;
      case "M":
        this.b_Edit(this._CurrentId);
        break;
      case "O":
        Link += "/" + this._CurrentId+"/"+encodeURIComponent(this._CurrentName);
        this.router.navigate([Link], { skipLocationChange: true });
        break;
      default:
        this.router.navigate([Link], { skipLocationChange: true });
        break;
    }
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  b_Add() {
  //  const dialogConfig : MatDialogConfig=
  //  {
  //    disableClose: true,
  //    autoFocus : true,
  //    panelClass : "my-class"
  //  };
  //  const dialogRef = this.dialog.open(IOptionGroupsAddComponent, dialogConfig);
  //  dialogRef.afterClosed().subscribe(
  //    data => {
  //      if (data) {
  //        console.log("grabado");
  //        this.Filter();
  //      }
  //      else {
  //        console.log('Undefined data.');
  //      }
  //    }, (e) => console.log(e)
  //  );
  }

  b_Edit(_id) {
  //  const dialogConfig = new MatDialogConfig();
  //  dialogConfig.disableClose = true;
  //  dialogConfig.autoFocus = true;
  //  dialogConfig.panelClass = "my-class";
  //  dialogConfig.data = { id:_id };
  //  const dialogRef = this.dialog.open(OptionGroupsEditComponent, dialogConfig);
  //  dialogRef.afterClosed().subscribe(
  //    data => {
  //      if (data) {
  //        this.Filter();
  //        console.log("grabado");
  //      }
  //      else {
  //        console.log('Undefined data.');
  //      }
  //    }, (e) => console.log(e)
  //  );
  }

  b_Detail(_id) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.panelClass = "my-class-detail";
      dialogConfig.data = { id:_id };
      const dialogRef = this.dialog.open(CompositionDetailComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(
        data => {
          if (data) {
            //this.Filter();
            //console.log("grabado");
          }
          else {
            //console.log('Undefined data.');
          }
        }, (e) => console.log(e)
      );
  }

}
